const LauguageEnum = Object.freeze({
  PATTERN_0: { value: 'zh_CN', text: '简体中文' },
  PATTERN_1: { value: 'en_US', text: 'English' },
  PATTERN_2: { value: 'fr_FR', text: 'French' }
})

const getList = function(hasEmpty){
  let options = []
  if(hasEmpty){
    options.push({value:'',text:''})
  }
  for(let key of Object.keys(LauguageEnum)){
    options.push({value:LauguageEnum[key].value,text:LauguageEnum[key].text})
  }
  return options
}

const getText = function(val){
  for(let key of Object.keys(LauguageEnum)){
    if(key === val){
      return LauguageEnum[key].text
    }
  }
}

const getTextByVal = function(val){
  for(let key of Object.keys(LauguageEnum)){
    if(LauguageEnum[key].value === val){
      return LauguageEnum[key].text
    }
  }
}

const result = {
  enum: LauguageEnum,
  getList: getList,
  getText: getText,
  getTextByVal: getTextByVal
}

export default result